import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import DtPicker, { convertToEn, convertToFa } from 'react-calendar-datetime-picker';
import { Form } from 'react-bootstrap';

function DateTimePicker(props) {
  let {
    placeholder,
    label,
    name,
    onChange,
    control,
    rules,
    error,
    minDate,
    onCalenderShow,
    initValue,
    classes,
    isDisabled,
  } = props;

  let conditionalProps = {
    ...(onCalenderShow && { onCalenderShow }),
    ...(classes.timeClass && { timeClass: classes.timeClass }),
    ...(initValue && { initValue: convertDateToGet(initValue) }),
  };

  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      <Controller
        as={
          <DtPicker
            clearBtn
            local={'fa'}
            withTime
            minDate={convertDateToSend(minDate)}
            placeholder={placeholder}
            inputClass={`form-control px-2 py-4 ${error && 'border border-danger'}`}
            {...conditionalProps}
          />
        }
        rules={rules}
        name={name}
        control={control}
        onChange={([selected]) => {
          if (selected) {
            let newSelected = Date.parse(convertToEn(selected));
            newSelected = new Date(newSelected).toISOString();

            return newSelected;
          }
        }}
      />
      {error && <span className="text-danger">{error.message}</span>}
    </Form.Group>
  );
}

function convertDateToSend(date) {
  let dateObj = new Date();
  if (date) dateObj = new Date(date);

  let convertedDate = convertToFa({
    year: dateObj.getFullYear(),
    month: dateObj.getMonth() + 1,
    day: dateObj.getDate(),
  }).split('/');

  let finaleDateObj = {
    year: parseInt(convertedDate[0]),
    month: parseInt(convertedDate[1]),
    day: parseInt(convertedDate[2]),
  };
  return finaleDateObj;
}

function convertDateToGet(date) {
  let dateObj = new Date();
  if (date) dateObj = new Date(date);

  let convertedDate = convertToFa({
    year: dateObj.getFullYear(),
    month: dateObj.getMonth() + 1,
    day: dateObj.getDate(),
  }).split('/');

  let finaleDateObj = {
    year: parseInt(convertedDate[0]),
    month: parseInt(convertedDate[1]),
    day: parseInt(convertedDate[2]),
  };
  return finaleDateObj;
}

DateTimePicker.propTypes = {
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  rules: PropTypes.object.isRequired,
  error: PropTypes.object.isRequired,
  minDate: PropTypes.object,
  onCalenderShow: PropTypes.func,
  initValue: PropTypes.oneOfType(PropTypes.string, PropTypes.object),
};

export default DateTimePicker;
